import { ReactComponent as SpeedometerIcon } from './speedometer.svg';

export default SpeedometerIcon;
